import { type KycState } from "./state";

export const initialState: KycState = {
  customerName: "",
  customerNationalId: "",
  dpiCheck: null,
  captures: [],
  isPending: false,
  isRejected: false,
  isUploading: false,
  uploadError: "",
  errorMessage: "",
};
